import { styled } from "@mui/material/styles";

const TopAndTabBarContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  transition: "transform 300ms ease-in-out",
  width: "100%",
  zIndex: theme.zIndex.appBar - 1,
}));

export default TopAndTabBarContainer;
